import { root, getServiceVersion } from '@estee/elc-universal-utils';
import { getDecorators } from '@estee/elc-service';
import { Container } from 'hypo-container';
import { ProductRatingViewController } from '../internal/controllers/ProductRatingViewController';
import { ProductReviewsViewController } from '../internal/controllers/ProductReviewsViewController';
import { ReviewDetailsViewController } from '../internal/controllers/ReviewDetailsViewController';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { ProductRepository } from '../internal/repositories/ProductRepository';
import { Config } from '../internal/domain/entities/Config';
import { RatingsAndReviewsApiSdk } from '../api/RatingsAndReviewsApiSdk';
import { ServiceBusController } from './ServiceBusController';
import { RatingsReviewsService } from './RatingsReviewsService';
import { ConfigStore } from './ConfigStore';
import { RatingsRepository } from '../internal/repositories/RatingsRepository';

export const diContainer = new Container();
export const serviceNames = {
    configStore: 'CONFIG_STORE',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    ratingsReviewsService: 'RATINGS_REVIEWS_SERVICE',
    productRatingViewController: 'PRODUCT_RATING_VIEW_CONTROLLER',
    productReviewsViewController: 'PRODUCT_REVIEWS_VIEW_CONTROLLER',
    reviewDetailsViewController: 'REVIEW_DETAILS_VIEW_CONTROLLER',
    productRepository: 'PRODUCT_REPOSITORY',
    ratingsRepository: 'RATINGS_REPOSITORY',
    ratingsReviewsApiSdk: 'REVIEW_SNIPPET_API_SDK',
    httpTransport: 'HTTP_TRANSPORT'
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.config, (c) => new Config())
    .register(serviceNames.configRepository, () => new ConfigRepository())
    .register(
        serviceNames.serviceBusController,
        (c) => new ServiceBusController(c.get(serviceNames.ratingsRepository))
    )
    .register(
        serviceNames.ratingsReviewsService,
        (c) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            new RatingsReviewsService((config: any) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    )
    .register(
        serviceNames.productRatingViewController,
        diContainer.factory(
            (c) =>
                new ProductRatingViewController(
                    c.get(serviceNames.productRepository),
                    c.get(serviceNames.ratingsRepository)
                )
        )
    )
    .register(
        serviceNames.productReviewsViewController,
        diContainer.factory(
            (c) =>
                new ProductReviewsViewController(
                    c.get(serviceNames.config),
                    c.get(serviceNames.productRepository)
                )
        )
    )
    .register(serviceNames.ratingsReviewsApiSdk, (c) => {
        const config = {
            httpTransport: c.get(serviceNames.httpTransport),
            configStore: c.get(serviceNames.configStore)
        };
        const reviewSnippetServiceName = serviceNames.ratingsReviewsApiSdk;
        const reviewSnippetServiceVersion = getServiceVersion(reviewSnippetServiceName);

        return new RatingsAndReviewsApiSdk(
            config,
            reviewSnippetServiceName,
            reviewSnippetServiceVersion
        );
    })
    .register(serviceNames.httpTransport, (c) => {
        return root.HttpTransport;
    })
    .register(
        serviceNames.productRepository,
        (c) => new ProductRepository(c.get(serviceNames.config))
    )
    .register(serviceNames.ratingsRepository, (c) => new RatingsRepository())
    .register(
        serviceNames.reviewDetailsViewController,
        (c) => new ReviewDetailsViewController(c.get(serviceNames.configStore))
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
